var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 900 829"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 36"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 35"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 184",
  d: "M90 135c0 74.443 60.557 135 135 135s135-60.557 135-135S299.443 0 225 0 90 60.557 90 135z",
  fill: "#cdebfc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 185",
  d: "M360 135C360 60.557 299.443 0 225 0v270c74.443 0 135-60.557 135-135z",
  fill: "#bfe1fd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 186",
  d: "M0 497a14.991 14.991 0 0015 15h420a14.991 14.991 0 0015-15c0-107.52-87.48-197-195-197h-60C87.48 300 0 389.48 0 497z",
  fill: "#cdebfc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 187",
  d: "M255 300h-30v212h210a14.991 14.991 0 0015-15c0-107.52-87.48-197-195-197z",
  fill: "#bfe1fd"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "user"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 184",
  d: "M315 282c0 74.443 60.557 135 135 135s135-60.557 135-135-60.557-135-135-135-135 60.557-135 135z",
  fill: "#45c1f1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 185",
  d: "M585 282c0-74.443-60.557-135-135-135v270c74.443 0 135-60.557 135-135z",
  fill: "#44a4ec"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 186",
  d: "M225 644a14.991 14.991 0 0015 15h420a14.991 14.991 0 0015-15c0-107.52-87.48-197-195-197h-60c-107.52 0-195 89.48-195 197z",
  fill: "#45c1f1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 187",
  d: "M480 447h-30v212h210a14.991 14.991 0 0015-15c0-107.52-87.48-197-195-197z",
  fill: "#44a4ec"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "user"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 184",
  d: "M540 452c0 74.443 60.557 135 135 135s135-60.557 135-135-60.557-135-135-135-135 60.557-135 135z",
  fill: "#ffe478"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 185",
  d: "M810 452c0-74.443-60.557-135-135-135v270c74.443 0 135-60.557 135-135z",
  fill: "#ffca36"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 186",
  d: "M450 814a14.991 14.991 0 0015 15h420a14.991 14.991 0 0015-15c0-107.52-87.48-197-195-197h-60c-107.52 0-195 89.48-195 197z",
  fill: "#ffe478"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 187",
  d: "M705 617h-30v212h210a14.991 14.991 0 0015-15c0-107.52-87.48-197-195-197z",
  fill: "#ffca36"
}))))));
export default SvgPeople;